window.onload = (e) => {
  TopSwiper();
  LowerSwiper();
  initMenuToggle();
  initSmoothScroll();
  faqAccordion();
  galleryModal();
  storyModal();
};

$(window).on("load", function () {
  const mv = $(".mv");
  mv.addClass("is-loaded");
});

function galleryModal() {
  const modalBtns = document.querySelectorAll(".gallery-item");
  modalBtns.forEach(function (btn) {
    btn.onclick = function () {
      var modal = btn.getAttribute("data-modal");
      document.getElementById(modal).style.display = "block";
    };
  });
  const closeBtns = document.querySelectorAll(".modalClose");
  closeBtns.forEach(function (btn) {
    btn.onclick = function () {
      var modal = btn.closest(".modal-item");
      modal.style.display = "none";
    };
  });

  window.onclick = function (event) {
    if (event.target.className === "modal") {
      event.target.style.display = "none";
    }
  };
}

function storyModal() {
  const modalBtns = document.querySelectorAll(".story-item");
  modalBtns.forEach(function (btn) {
    btn.onclick = function () {
      var modal = btn.getAttribute("data-modal-story");
      document.getElementById(modal).style.display = "block";
    };
  });
  const closeBtns = document.querySelectorAll(".story-modalClose");
  closeBtns.forEach(function (btn) {
    btn.onclick = function () {
      var modal = btn.closest(".story-modal-item");
      modal.style.display = "none";
    };
  });

  window.onclick = function (event) {
    if (event.target.className === "modal") {
      event.target.style.display = "none";
    }
  };
}

function TopSwiper() {
  const swiper = new Swiper(".swiper", {
    slidesPerView: 1.3,
    spaceBetween: 22,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });
}

function LowerSwiper() {
  const swiperGallery = new Swiper(".gallery-slider", {
    loop: true,
    loopedSlides: 2,
    loopAdditionalSlides: 2,
    slidesPerView: "auto",
    spaceBetween: 10,
    speed: 6000,
    centeredSlides: true,
    autoplay: {
      delay: 0, // 途切れなくループ
    },
  });
}

function initSmoothScroll() {
  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));
    if (target.length) {
      event.preventDefault();
      var headerHeight = $("header").outerHeight();
      var width = window.innerWidth;
      if (width < 1100) {
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: target.offset().top - headerHeight,
            },
            200
          );
      } else {
        $("html, body").stop().animate(
          {
            scrollTop: target.offset().top,
          },
          200
        );
      }
    }
  });
}

function initMenuToggle() {
  document.addEventListener("click", (e) => {
    const hamburger = document.querySelector(".hamburger");
    if (!hamburger) return;
    const isFiredInToggle = hamburger.contains(e.target);
    const isMenuOpened =
      document.querySelector(".hamburger.is-opened") !== null;
    if (!isFiredInToggle || isMenuOpened) return;

    hamburger.classList.add("is-opened");
    const globalNav = document.querySelector(".header-content");
    globalNav.classList.add("is-opened");
    const hideMenu = (e) => {
      globalNav.classList.remove("is-opened");
      hamburger.classList.remove("is-opened");
      document.removeEventListener("click", hideMenu);
    };
    document.addEventListener("click", hideMenu);
  });
}

function faqAccordion() {
  $(".faq-list__item dt").on("click", function () {
    $(this).parents(".faq-list__item").toggleClass("is-open");
    $(this).next(".faq-list__item dd").slideToggle();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // フェードインさせる対象の要素を取得
  const fadeInElements = document.querySelectorAll(".fade-in");

  // IntersectionObserverのオプション
  const observerOptions = {
    root: null, // ビューポートを基準に監視
    rootMargin: "0px", // 余白なし
    threshold: 0.1, // 10%以上表示されたらトリガー
  };

  // IntersectionObserverのコールバック関数
  const fadeInCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible"); // "visible"クラスを追加
        observer.unobserve(entry.target); // 一度フェードインしたら監視を解除
      }
    });
  };

  // IntersectionObserverを作成
  const observer = new IntersectionObserver(fadeInCallback, observerOptions);

  // 対象の要素を監視
  fadeInElements.forEach((el) => observer.observe(el));
});
